import { PageController } from '@client/components/_core/layout/PageController';
import { NewRegisterAction } from '@client/components/registers/NewRegisterAction';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

/**
 * `?open=gallery` used to open the Add a register gallery on arrival — the landing for the What's
 * new Registers note's call to action (CUR-1094 req. 3). The gallery is now the `add` overlay
 * route, so the old link redirects there. Optional so the plain URL stays clean; a malformed value
 * is ignored rather than erroring the route.
 */
const REGISTERS_SEARCH_SCHEMA = z.object({
    open: z.literal('gallery').optional().catch(undefined),
});

export const Route = createFileRoute('/console/$orgId/compliance/registers/_list/')({
    validateSearch: zodValidator(REGISTERS_SEARCH_SCHEMA),
    beforeLoad: ({ search, params }): void => {
        if (search.open === 'gallery') {
            throw redirect({ to: '/console/$orgId/compliance/registers/add', params, replace: true });
        }
    },
    component: RegistersIndex,
});

function RegistersIndex() {
    // The list itself is rendered by the parent layout. This leaf only contributes the header
    // action, which `PageLayout.Header` shows from the leaf route when no overlay is open.
    return (
        <PageController route={Route}>
            <NewRegisterAction />
        </PageController>
    );
}
